import { render, staticRenderFns } from "./xiaoche.vue?vue&type=template&id=5d46005f&scoped=true&"
import script from "./xiaoche.vue?vue&type=script&lang=js&"
export * from "./xiaoche.vue?vue&type=script&lang=js&"
import style0 from "./xiaoche.vue?vue&type=style&index=0&id=5d46005f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46005f",
  null
  
)

export default component.exports